<script lang="ts">
	import { onMount, onDestroy } from "svelte";

	import { yyyy, zzzz } from "../store.svelte";

	import CardMaplibre from "../charts/CardMaplibre.svelte";
	import CardLeaflet from "../charts/CardLeaflet.svelte";
	import Settings from "./Settings.svelte";
	import { createMapDivForPolygon } from "../extras/fakeMap.svelte";
	import Fa from "svelte-fa";
	import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

	let ready: boolean = $state(false);

	interface lvwrprops {
		livewire: string;
		owner: string;
		description: string;
		g: string;
		isready: boolean;
		propagate: string[];
		ispublic: boolean;
		ispinned: boolean;
		wireident: string;
		chronicle?: any[];
		index?: number;
	}

	let {
		livewire,
		owner,
		description,
		g,
		isready,
		ispinned,
		propagate,
		ispublic,
		wireident,
		chronicle = [],
		index = 0,
	}: lvwrprops = $props();

	// Pending update: this livewire is a predecessor and the new version is still generating
	let pendingUpdate = $derived(
		chronicle.length > 0 &&
		yyyy.livewires?.some((lw: any) =>
			chronicle.some((c: any) => c.livewire_id === lw.wireident && !lw.isready)
		)
	);

	let displaySettings: boolean = $state(false);

	let toggleSettings = () => {
		displaySettings = !displaySettings;
	};

	let showMap = () => {
		yyyy.sesh.activeLivewire = {
			wireident: wireident,
			livewire: livewire,
			extent: g,
			owner: owner,
		};

		// Emit tour advance event if tour is active
		zzzz.emit('tour-advance');

		
		// Reset camera state when switching livewires
		yyyy.camera = { show: false };

		zzzz.emit("map-active");
	};

	onMount(() => {
		setTimeout(() => {
			ready = true;
			yyyy.logo.usage = "logo";
		}, yyyy.logo.time);
	});

	onDestroy(() => {
		yyyy.logo.time = 877.5;
		yyyy.logo.usage = "wait";
	});
</script>

<!-- <svelte:window on:pushstate={routing} /> -->
<div id="lvwr-{String(index + 1).padStart(2, '0')}" class="column is-one-quarter porridge livewire-card-wrapper" data-wireident={wireident}>
	<div class="card lvwr-card" class:zeroBG={!ready}>
		<div  id="lvwr-{String(index + 1).padStart(2, '0')}-map"  class="card-image map-holder">
			{#if yyyy.map.cardEngine === "Leaflet"}
				<CardLeaflet {g} {wireident} />
			{:else}
				<CardMaplibre {g} {wireident} />
			{/if}
			{#if pendingUpdate}
				<div class="pending-badge">Update pending</div>
			{/if}
		</div>
		<div  id="lvwr-{String(index + 1).padStart(2, '0')}-info"     class="card-content lvwr-card-content">
			<div class="media">
				<div class="media-content">
					<p class="title is-4 lvwr-title">{livewire}</p>
					<p class="subtitle is-6 lvwr-subtitle">
						{owner}
					</p>
				</div>
			</div>
			<div class="content lvwr-content">{description}</div>
		</div>
		<footer
			class="card-footer"
			class:dim={!ready}
			class:bri={ready}
			class:showpinned={ispinned}
		>
			<div class="card-footer-item sign-in-up-footer">
				<button
id="lvwr-{String(index + 1).padStart(2, '0')}-more"
					class="button lvwr-toggle-outlined is-small"
					onclick={toggleSettings}
				>
					<Fa icon={faEllipsisH} />
				</button>
				<button 
id="lvwr-{String(index + 1).padStart(2, '0')}-open"
					class="button lvwr-toggle" onclick={showMap}>Open </button>
			</div>
		</footer>
	</div>
</div>

{#if displaySettings}
	<Settings
		{livewire}
		{wireident}
		{ispublic}
		{owner}
		{propagate}
		{ispinned}
		{description}
		bind:displaySettings
	/>
{/if}

<style>

	.porridge {
		width: 475px;
	}

	.map-holder {
		height: 235px;
	}
	.lvwr-card-content {
		height: 175px;
		padding: 1em;
	}
	.sign-in-up-footer {
		justify-content: space-between;
	}

	.zeroBG {
		background-color: #fff0;
		box-shadow: none;
		transition: background-color 2.5s ease;
	}

	.dim {
		opacity: 0%;
		transition: opacity 2.5s ease;
	}

	.bri {
		opacity: 100%;
		transition: opacity 2.5s ease;
	}

	.showpinned {
		border-top-width: 1px;
		border-top-style: solid;
		border-top-color: #ff3e00;
	}

	.map-holder {
		position: relative;
	}

	.pending-badge {
		position: absolute;
		bottom: 0.5rem;
		left: 0.5rem;
		font-size: 0.7rem;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		color: white;
		background: rgba(255, 62, 0, 0.85);
		padding: 0.25rem 0.6rem;
		border-radius: 3px;
		z-index: 999;
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0%, 100% { opacity: 1; }
		50% { opacity: 0.5; }
	}
</style>
